import { Carousel } from 'react-bootstrap';
import slide from '../assets/Home page.jpg'
import slide2 from '../assets/Home page 2.jpg'
import slide3 from '../assets/Home page 3.jpg'

const HeroSection = () => {

    return (
        <div style={{ position: 'relative' }} id='homebanner'>
            {/* Carousel */}
            <Carousel fade indicators={false}>
                <Carousel.Item>
                    <img
                        className="d-block w-100 caro-img"
                        src={slide}
                        alt="First slide"
                        loading="lazy"
                    />


                </Carousel.Item>

                <Carousel.Item>
                    <img
                        className="d-block w-100 caro-img"
                        src={slide2}
                        alt="Second slide"
                        loading="lazy"
                    />
                </Carousel.Item>

                <Carousel.Item>
                    <img
                        className="d-block w-100 caro-img"
                        src={slide3}
                        alt="Second slide"
                        loading="lazy"
                    />
                </Carousel.Item>

            </Carousel>

        </div>
    );
};

export default HeroSection